<ng-container *transloco="let t">
  <pxw-modal-dialog icon="alert" [title]="t('error.title')" type="alert">
    <pxw-icon icon="alert" />
    <p>{{ t('subsidiaries.geolocationError') }}</p>
  </pxw-modal-dialog>
</ng-container>
